import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import Router from './router/Router';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './store/Store';
import 'dayjs/locale/es';
import 'dayjs/locale/en';
import { createTheme } from '@mui/material';
import { ThemeProvider } from '@mui/material';
import dayjs from 'dayjs';
import { SnackbarProvider } from 'notistack';
import { BLUE_COLOR } from './constants/ColorsConst';

dayjs.locale('es');

const theme = createTheme({
  palette: {
    primary: {
      main: BLUE_COLOR,
    },
  },
});

const App = () => (
  // <ErrorBoundaryComponent>
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Suspense fallback={<div>Loading</div>}>
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            autoHideDuration={4000}
            onClose={() => {}}
          >
            <Router />
          </SnackbarProvider>
        </Suspense>
      </PersistGate>
    </Provider>
  </ThemeProvider>
  // {/* </ErrorBoundaryComponent> */ }
);

ReactDOM.render(<App />, document.getElementById('root'));

// https://github.com/azizmashkour/react-i18n/blob/master/src/App.js
